module.exports = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  // API_BASE_URL: 'http://api.hipcouch.com',
};
